export default {"src":"/_next/static/media/lace.1e60df7a.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};